export default __webpack_public_path__ + "static/media/eb_minor.7b7135e0.jpg";